import React from 'react';
import { fireEvent, render } from '@testing-library/react';
import LocalizedPasswordField from './LocalizedPasswordField';

describe('LocalizedPasswordField', () => {
  const labels = {
    label: 'Contraseña',
    showPasswordLabel: 'Mostrar contraseña',
    hidePasswordLabel: 'Ocultar contraseña',
  };

  it('renders the provided label instead of the KDS default', () => {
    const { getByText, queryByText } = render(
      <LocalizedPasswordField {...labels} name="password" />,
    );

    expect(getByText('Contraseña')).toBeInTheDocument();
    expect(queryByText('Password')).not.toBeInTheDocument();
  });

  it('renders a working show / hide password toggle', () => {
    const { getByTestId } = render(
      <LocalizedPasswordField {...labels} name="password" />,
    );

    // The toggle drives password visibility; its localized Show/Hide tooltip
    // text flows through the same passwordField translations as the label
    // asserted above.
    expect(getByTestId('toggle-password-visible')).toHaveAttribute(
      'aria-expanded',
      'false',
    );

    // The icon is swapped on toggle, so re-query for the fresh element.
    fireEvent.click(getByTestId('toggle-password-visible'));
    expect(getByTestId('toggle-password-visible')).toHaveAttribute(
      'aria-expanded',
      'true',
    );
  });

  it('falls back to the KDS English defaults when labels are omitted', () => {
    const { getByText } = render(<LocalizedPasswordField name="password" />);

    expect(getByText('Password')).toBeInTheDocument();
  });
});
